import React from 'react'
import { Link } from 'react-router-dom'
const BreadCrumbs = ({ title1, title2, title3 }) => {
    return (
        <>
            {/* <!-- ======================= Top Breadcrubms ======================== --> */}
            <div className="gray py-3">
                <div className="container">
                    <div className="row">
                        <div className="colxl-12 col-lg-12 col-md-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">

                                    <li className="breadcrumb-item"><Link to={"/"}>{title1}</Link></li>
                                    <li className="breadcrumb-item">{title2}</li>
                                    <li className="breadcrumb-item active" aria-current="page">{title3}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- ======================= Top Breadcrubms ======================== --> */}</>
    )
}

export default BreadCrumbs